import React from 'react';
import LogoHeader from '../../atoms/Logo';
import { WrapperHeader } from './styles';

const Header = () => {
  return (
    <WrapperHeader>
      <div className="header">
        <div className="container">
          <LogoHeader />
        </div>
      </div>
    </WrapperHeader>
  );
}

export default Header;